export const LOAD_TEAMS_SUCCESS = "LOAD_TEAMS_SUCCESS";

export const LOAD_TEAM_SUCCESS = "LOAD_TEAM_SUCCESS";

export const CREATE_TEAM_SUCCESS = "CREATE_TEAM_SUCCESS";

export const SAVE_TEAM_SUCCESS = "SAVE_TEAM_SUCCESS";

export const DELETE_TEAM_SUCCESS = "DELETE_TEAM_SUCCESS";

export const CREATE_TEAM = "CREATE_TEAM";

export const SAVE_TEAM = "SAVE_TEAM";

export const LOAD_TEAMS = "LOAD_TEAMS";

export const LOAD_TEAM_DETAIL = "LOAD_TEAM_DETAIL";

export const DELETE_TEAM = "DELETE_TEAM";
